import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import App from './App';


const PanelWithAuth = lazy(() => import('./panel/PanelWithAuth'));
const VehicleTrackingWithAuth = lazy(() => import('./panel/VehicleTrackingWithAuth'));
const Login = lazy(() => import('./auth/Login'));
const HaritaLogin = lazy(() => import('./harita/HaritaLogin'));
const HaritaWithAuth = lazy(() => import('./HaritaWithAuth'));
const TemizlikWithAuth = lazy(() => import('./TemizlikWithAuth'));
const TalepWithAuth = lazy(() => import('./TalepWithAuth'));
const RamazanWithAuth = lazy(() => import('./RamazanWithAuth'));
const RamazanAramaWithAuth = lazy(() => import('./RamazanAramaWithAuth'));
const MuhtarWithAuth = lazy(() => import('./muhtar/MuhtarWithAuth'));
const KonumApp = lazy(() => import('./konum/KonumApp'));
const InsaatWithAuth = lazy(() => import('./InsaatWithAuth'));
const PdfWithAuth = lazy(() => import('./pdf/PdfWithAuth'));
const ParcelMapPage = lazy(() => import('./parsel/ParcelMapPage'));
const TenisMap = lazy(() => import('./tenis/TenisMap'));

const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    fontSize: '18px',
    color: '#666'
  }}>
    Yükleniyor...
  </div>
);

export default function Router() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route
          path="/panel/login"
          element={<Login />}
        />
        <Route
          path="/harita/login"
          element={<HaritaLogin />}
        />
        <Route
          path="/panel"
          element={<PanelWithAuth />}
        />
        <Route
          path="/panel/arac-takip"
          element={<VehicleTrackingWithAuth />}
        />
        <Route
          path="/pdf"
          element={<PdfWithAuth />}
        />
        <Route
          path="/harita"
          element={<HaritaWithAuth />}
        />
        <Route
          path="/parsel"
          element={<ParcelMapPage />}
        />
        <Route
          path="/temizlik"
          element={<TemizlikWithAuth />}
        />
        <Route
          path="/talep"
          element={<TalepWithAuth />}
        />
        <Route
          path="/ramazan"
          element={<RamazanWithAuth />}
        />
        <Route
          path="/ramazan-baskan"
          element={<RamazanWithAuth onlyBaskan={true} />}
        />
        <Route
          path="/ramazan-harita"
          element={<RamazanWithAuth mapOnly={true} />}
        />
        <Route
          path="/ramazan-arama"
          element={<RamazanAramaWithAuth />}
        />
        <Route
          path="/muhtar"
          element={<MuhtarWithAuth />}
        />
        <Route
          path="/konum"
          element={<KonumApp />}
        />
        <Route
          path="/insaat"
          element={<InsaatWithAuth />}
        />
        <Route
          path="/tenis"
          element={<TenisMap />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
